import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import CampaignModel from 'cio/models/campaign';
import BaseCampaignOverviewSubjectsIndexController from './controller';

export default class CampaignOverviewSubjectsIndexRoute extends Route {
  templateName = 'base/overview/subjects/index';

  crumb() {
    return {
      name: 'Journeys',
      path: this.routeName,
    };
  }

  setupController(
    controller: BaseCampaignOverviewSubjectsIndexController,
    model: CampaignModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    controller.continuation = null;
  }
}
